// ACLS Bag checklist — items per pocket, [key, label, target quantity].

export const BAG_FRONT_POCKET = [
  ["opa", "OPA (00,1,2,3,4)", "1"],
  ["npa", "NPA (7,8)", "1"],
  ["bvm", "BVM (Adult & Neonate)", "1"],
] as const;

export const BAG_CENTRAL_POCKET = [
  ["ivCannula", "IV Cannula (14,18,20,22,24,26)", "1"],
  ["tegadermPlasterTourniquet", "Tegaderm & Plaster & Tourniquet", "1"],
  ["gauze4x4", "Gauze 4×4", "2 BOX"],
  ["paraffinGauze10x10", "Paraffin Gauze 10×10", "4"],
  ["paraffinGauze5x5", "Paraffin Gauze 5×5", "4"],
  ["crepeBandage", "Crepe Bandage 10cm × 4.5m", "2"],
  ["conformingBandage", "Conforming Bandage", "2"],
  ["cannulaSet", "Cannula Set", "2"],
  ["nasalMaskAdult", "Nasal Mask (Adult)", "2"],
  ["nasalMaskPedia", "Nasal Mask (Pedia)", "2"],
  ["simpleMaskPedia", "Simple Mask (Pedia)", "2"],
  ["simpleMaskAdult", "Simple Mask (Adult)", "2"],
  ["nrmAdult", "NRM (Adult)", "2"],
  ["nrmPedia", "NRM (Pedia)", "2"],
  ["eyePads", "Eye Pads", "3"],
  ["razor", "Razor", "1"],
  ["syringes", "Syringes (1,3,5,10,20,50 ML)", "1"],
  ["plaster", "Plaster", "1"],
  ["tourniquet", "Tourniquet", "1"],
  ["alcoholSwab", "Alcohol Swab", "1 BOX"],
  ["lma", "LMA (1,2,3,4,5)", "1"],
] as const;

export const BAG_BACK_POCKET = [
  ["icePack", "Ice Pack", "2"],
  ["flushSalineSyringe", "Flush Saline Syringe", "3"],
  ["cCollar", "C-Collar", "1"],
  ["triangularBandage", "Triangular Bandage", "1"],
] as const;

export const BAG_SECTIONS = [
  { key: "frontPocket", title: "Front Pocket", items: BAG_FRONT_POCKET },
  { key: "centralPocket", title: "Central Pocket", items: BAG_CENTRAL_POCKET },
  { key: "backPocket", title: "Back Pocket", items: BAG_BACK_POCKET },
] as const;
